import { connect } from 'react-redux';

import Listing from './Listing';
import {
  selectType,
  selectAllTypes,
  deselectAllTypes,
  deleteMember,
  filterTypeData,
  setFilterQuery,
  getWorkforceList,
  loadMoreWorkforceMembers,
  getWorkforceGroupData,
  fetchAllWorkforceMembersForExport,
} from './actions';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  pending: state.auth.workforceMembers.listPage.data.pending,
  chunks: state.auth.workforceMembers.listPage.data.chunks,
  allRecords: state.auth.workforceMembers.listPage.data,
  filteredChunks: state.auth.workforceMembers.listPage.data.filteredChunks,
  error: state.auth.workforceMembers.listPage.data.error,
  items: state.auth.workforceMembers.listPage.data.items,
  filter: state.auth.workforceMembers.listPage.data.filter,
  selected: state.auth.workforceMembers.listPage.data.selected,
  selectAll: state.auth.workforceMembers.listPage.data.selectAll,
  hasMore: state.auth.workforceMembers.listPage.data.hasMore,
  loadingMore: state.auth.workforceMembers.listPage.data.loadingMore,
  totalCount: state.auth.workforceMembers.listPage.data.totalCount,
  allGroups: state.auth.memberGroups.listPage.data.chunks,
  allGroupsData: state.auth.workforceMembers.listPage.data.allGroupsData,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSelect: key => dispatch(selectType(key)),
  onSelectAllTypes: () => dispatch(selectAllTypes()),
  onDeselectAllTypes: () => dispatch(deselectAllTypes()),
  onDeleteSelected: () => dispatch(deleteMember(ownProps.match.params.appname)),
  onFilterTypeData: filter => dispatch(filterTypeData(filter)),
  setFilterQuery: filter => dispatch(setFilterQuery(filter)),
  getWorkforceList: () =>
    dispatch(getWorkforceList(ownProps.match.params.appname)),
  loadMoreWorkforceMembers: () =>
    dispatch(loadMoreWorkforceMembers(ownProps.match.params.appname)),
  getWorkforceGroupData: () =>
    dispatch(getWorkforceGroupData(ownProps.match.params.appname)),
  fetchAllWorkforceMembersForExport: app =>
    dispatch(fetchAllWorkforceMembersForExport(app)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Listing);
